
const intlActionType ={
    SWITCH_LANGUAGE:'SWITCH_LANGUAGE',
    SWITCH_DIRECTION:'SWITCH_DIRECTION'
}    
export default intlActionType;